import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Link, withRouter } from "react-router";

import { isActiveRoute, renderTitle } from "../lib/routing";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import navigation from "../lib/navigation-utilities";

const MenuItem = ({ isActive, path, test, description }) => (
  <Link
    to={path}
    role="tab"
    className={"nav-link" + (isActive(test) ? " active" : "")}>
    <div className="d-flex justify-content-between align-items-center">
      <div>{description}</div>
      <FontAwesomeIcon icon={["fas", "chevron-right"]} size="xs" />
    </div>
  </Link>
);

const Profile = ({ location, children }) => (
  <Subscribe to={[ProfileContainer]}>
    {(profileContainer) => {
      const isActive = isActiveRoute(location);
      const titleRenderer = renderTitle(location);

      return (
        <>
          <div className="container mt-5">
            <div className="row">
              <div className="col-sm-12">
                <h4 className="text-center mb-4">
                  {titleRenderer(
                    /^\/account\/profile\/profile_create$/i,
                    "Add User to Account"
                  )}

                  {titleRenderer(
                    /^(\/account\/profile\/profile_update|\/account\/profile)$/i,
                    "Update Personal Information"
                  )}

                  {titleRenderer(
                    /^\/account\/profile\/password_update$/i,
                    "Change Password"
                  )}

                  {titleRenderer(
                    /^\/account\/profile\/payment_method?/i,
                    "Payment Method"
                  )}

                  {titleRenderer(
                    /^\/account\/profile\/orders(\/\d+)?$/i,
                    "My Order Detail"
                  )}
                </h4>
              </div>
              <div className="col-sm-12 mt-5">
                <hr />
              </div>
            </div>
          </div>

          <div className="container dc-tabs my-5">
            <div className="row bg-white px-2 py-4 m-0">
              <div className="col-md-4">
                <div className="nav flex-column nav-pills d-none d-md-block">
                  {profileContainer.canCreateProfile() && (
                    <MenuItem
                      isActive={isActive}
                      path="/account/profile/profile_create"
                      test={/^\/account\/profile\/profile_create$/i}
                      description="Add User to Account"
                    />
                  )}

                  <MenuItem
                    isActive={isActive}
                    path="/account/profile/profile_update"
                    test={
                      /^(\/account\/profile\/profile_update|\/account\/profile)$/i
                    }
                    description="Update Personal Information"
                  />

                  {profileContainer.isCurrentProfilePrimary() && (
                    <MenuItem
                      isActive={isActive}
                      path="/account/profile/password_update"
                      test={/^\/account\/profile\/password_update$/i}
                      description="Change Password"
                    />
                  )}

                  {/* <MenuItem
                isActive={isActive}
                path="/account/profile/conveyance"
                test={/^\/account\/profile\/conveyance$/i}
                description="Update Delivery/Pickup Preference"
              /> */}

                  {profileContainer.isCurrentProfilePrimary() && (
                    <MenuItem
                      isActive={isActive}
                      path="/account/profile/payment_method"
                      test={/^\/account\/profile\/payment_method?/i}
                      description="Payment Method"
                    />
                  )}

                  {/* <MenuItem
                isActive={isActive}
                path="/account/profile/taste_profile"
                test={/^\/account\/profile\/taste_profile$/i}
                description="My Taste Profile"
              /> */}

                  <MenuItem
                    isActive={isActive}
                    path="/account/profile/orders"
                    test={/^\/account\/profile\/orders(\/\d+)?$/i}
                    description="My Order Detail"
                  />

                  {/* <MenuItem
                isActive={isActive}
                path="/account/profile/account_status"
                test={/^\/account\/profile\/account_status$/i}
                description="Account Status"
              /> */}
                </div>
                <div className="d-md-none mb-4 pb-4">
                  <select
                    className="custom-select"
                    value={
                      location.pathname === "/account/profile"
                        ? "/account/profile/profile_update"
                        : location.pathname
                    }
                    onChange={(event) => navigation.push(event.target.value)}>
                    {profileContainer.canCreateProfile() && (
                      <option value="/account/profile/profile_create">
                        Add User to Account
                      </option>
                    )}
                    <option value="/account/profile/profile_update">
                      Update Personal Information
                    </option>
                    <option value="/account/profile/password_update">
                      Change Password
                    </option>
                    {/* <option value="/account/profile/conveyance">
                      Update Pick Up/Delivery Preferences
                    </option> */}
                    {profileContainer.isCurrentProfilePrimary() && (
                      <option value="/account/profile/payment_method">
                        Payment Method
                      </option>
                    )}
                    {/* <option value="/account/profile/taste_profile">
                      My Taste Profile
                    </option> */}
                    <option value="/account/profile/orders">
                      My Order Detail
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-md-8">{children}</div>
            </div>
          </div>
        </>
      );
    }}
  </Subscribe>
);

export default withRouter(Profile);
